export default "d908be770bb72a8a.png"